import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from "react-intl";

// Components
import Badge from "components/Badge";

// Utils
import {greyishBlue500} from "assets/jss/main";

WmsItemPlaces.propTypes = {
    wmsItem: PropTypes.shape({
        places: PropTypes.arrayOf(
            PropTypes.shape({
                name: PropTypes.string.isRequired
            })
        )
    })
};

function WmsItemPlaces({wmsItem}) {
    const [hasWmsPlace, setHasWmsPlace] = useState(true)

    if (!wmsItem) {
        return null;
    }

    useEffect(() => {
        if (!wmsItem.places || 0 === wmsItem.places.length) {
            setHasWmsPlace(false)
        }
    }, [wmsItem]);
    return (
        <div>
            <span
                style={{
                    fontWeight: 600,
                    fontSize: '12px',
                    color: greyishBlue500,
                }}
            >
                <FormattedMessage id='wms.myPickingMissions.popup.product.zones' />
            </span>
            <div
                style={{
                    display: 'flex',
                    gap:'8px'
                }}
            >
                {!hasWmsPlace && (
                    <Badge
                        style={{cursor: "loading"}}
                        key={0}
                        label={<FormattedMessage id={"wms.myPickingMission.toggle.noZone"}/>}
                        isBold={false}
                        size={"large"}
                    />
                )}

                {wmsItem.places?.map((place, index) => (
                    <Badge
                        style={{cursor: "loading"}}
                        key={index}
                        label={place.name}
                        isBold={false}
                        size={"large"}
                    />
                ))}
            </div>
        </div>
    );
}

export default WmsItemPlaces;
